import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const EmptyTable = (props) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{
        height: 400,
        background: "#fff",
        borderRadius: 5,
      }}
      className={props.com ? "widthIsh1" : "widthIsh"}
    >
      <Grid item>
        <Typography variant="h4" gutterBottom color="primary">
          No data yet
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          variant="body1"
          style={{ fontSize: "1rem" }}
          className="emptyMinText"
        >
          We have no computed data for this table
        </Typography>
      </Grid>
    </Grid>
  );
};

export default EmptyTable;
